export const UPDATE_REGISTRATION_TIER = "UPDATE_REGISTRATION_TIER";
export const CREATE_REGISTRATION_TIER = "CREATE_REGISTRATION_TIER";
export const DELETE_REGISTRATION_TIER = "DELETE_REGISTRATION_TIER";
export const FETCH_REVENUE_SPLITS = "FETCH_REVENUE_SPLITS";
export const AUTO_REGISTER = "AUTO_REGISTER";
export const CREATE_DESCRIPTIONS = "CREATE_DESCRIPTIONS";
